import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { useUser } from '~/modules/auth/hooks/useUser';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';
import { SETTINGS_ROUTES } from '~settings/config/routes';

import { type NavTab, NavTabs } from './NavTabs';
import { TabsHeader } from './TabsHeader';

export function TabsPagesLayout() {
  const { hasPermission } = useUser();
  const { t } = useTranslation('settings');
  const canViewLabelGroups = hasPermission('LABEL_GROUP.VIEW');
  const [labelGroupsEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerSettingsLabelGroups,
  ]);

  const tabs: NavTab[] = [
    { label: t('users'), path: SETTINGS_ROUTES.USER_LIST },
    { label: t('labels'), path: SETTINGS_ROUTES.LABEL_LIST },
  ];

  if (canViewLabelGroups && labelGroupsEnabled) {
    tabs.push({
      label: t('labelGroup.list'),
      path: SETTINGS_ROUTES.LABEL_GROUP_LIST,
    });
  }

  return (
    <>
      <TabsHeader />
      <NavTabs tabs={tabs} ariaLabel={t('settingsTabLabel')} />
      <Outlet />
    </>
  );
}

TabsPagesLayout.displayName = 'TabsPagesLayout';
